<template>
    <div id="color-picker" class="fade-in-up">
        <section class="gutter trim wrapper flex mb:flex--col">
            <div class="w-100 dt:mr">
                <gradient-picker v-if="pickerType"/>
                <hsl-sliders v-else class="sliders"/>
            </div>
            <div class="mb:w-100 mb:mt">
                <color-preview/>
                <div class="w-100 mt">
                    <picker-type-toggle v-model="pickerType"/>
                </div>
            </div>
        </section>

        <hr class="divider">

        <section class="gutter trim wrapper dt:flex">
            <div class="mb:w-100 dt:w-66">
                <rgb-sliders/>
            </div>
            <div class="mb:w-100 dt:w-33 mb:mt-6 dt:ml-4">
                <swatch-label/>
                <hex-field/>
                <hsv-fields/>
            </div>
        </section>

        <hr class="divider">

    </div>
</template>

<script>
    import HslSliders        from "./HslSliders";
    import RgbSliders        from "./RgbSliders";
    import SwatchLabel       from "./SwatchLabel";
    import HexField          from "./HexField";
    import HsvFields         from "./HsvFields";
    import CmykFields        from "./CmykFields";
    import Color             from "../../../../../Lib/Color";
    import UsesActivePalette from "../Palette/UsesActivePalette";
    import Swatches          from "../../../Store/Swatches";
    import DraftSwatch       from "../../../Store/DraftSwatch";
    import GradientPicker    from "./GradientPicker";
    import PickerTypeToggle  from "./PickerTypeToggle";
    import ColorPreview      from "./ColorPreview";
    import SaveButton        from "./SaveButton";
    import ResetButton       from "./ResetButton";

    export default {
        name: "color-picker",
        extends: UsesActivePalette,
        components: {
            ResetButton,
            SaveButton,
            ColorPreview,
            PickerTypeToggle,
            GradientPicker, RgbSliders, SwatchLabel, HslSliders, HexField, HsvFields, CmykFields
        },

        data() {
            return {
                draftSwatch: new DraftSwatch(),
                pickerType: true,
            }
        },

        computed: {
            swatch() {
                return this.activeSwatch;
            },
        },

        watch: {
            swatch() {
                if(!this.swatch) return;

                let draft = new DraftSwatch();

                let color = Color.fromRGB(this.swatch.color);
                draft.animateColorValues(color);
            }
        },
    }
</script>
